import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import * as XLSX from "xlsx";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { useGlobalState } from "../Context/GlobalStateContext";
import Confirmation from "../App/Confirmation";
import { SanitizeHtml, getAccessSettings } from "../Shared/Utility";

export default function IBBPaymentCriteria() {
  const globalState = useGlobalState();
  const [PaymentCriteriaGridData, setPaymentCriteriaGridData] = useState([]);
  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);
  {
    /*MM:: 1 means grid view.. 2 means add view and 3 means edit view*/
  }

  const [PaymentCriteriaData, setPaymentCriteriaData] = useState({}) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    IBBPaymentCriteriaGetCompleteGridDataCustom();
  }, []);

  function IBBPaymentCriteriaGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBPaymentCriteria/IBBPaymentCriteriaGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setPaymentCriteriaGridData(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBPaymentCriteriaSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbpaymentcriteriaid = PaymentCriteriaData.IBBPaymentCriteriaID;
    object.name = SanitizeHtml(PaymentCriteriaData.Name);
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBPaymentCriteria/IBBPaymentCriteriaSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          IBBPaymentCriteriaGetCompleteGridDataCustom();
          setCurrentView(1);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBPaymentCriteriaDeleteRecordCustom(IBBPaymentCriteriaID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbpaymentcriteriaid = IBBPaymentCriteriaID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBPaymentCriteria/IBBPaymentCriteriaDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBPaymentCriteriaGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBPaymentCriteriaDeleteRecordCustom(obj.SelectedID)
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID:0
    });
  }
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }
  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Payment Criteria List</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <span></span>
              <div className="flex-items">
            {getAccessSettings(2, 14) > 1 && <a
                className="btn-link"
                onClick={() => {
                  setPaymentCriteriaData({});
                  setCurrentView(2);
                  setCanEdit(true);
                }}
              >
                Add Payment Criteria
              </a>
              }
              <a
                className="btn-primary"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblProgramListPAYMENT", "PAYMENT CRITERIA LIST")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
            </div>
            <div className="section-table">
              <table className="part-head trend-table fixed-table" id="tblProgramListPAYMENT">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th className="md-col"></th>
                  </tr>
                </thead>
                <tbody>
                  {PaymentCriteriaGridData &&
                    PaymentCriteriaGridData.map((item: any, index: any) => (
                      <React.Fragment key={"PaymentCriteria" + index}>
                        <tr>
                          <td>{item.Name}</td>
                          <td className="md-col">
                            <div
                              className="width-100 text-center btn-sm-grid"
                              style={{ justifyContent: "flex-start" }}
                            >
                            {getAccessSettings(2, 14) > 1 &&  <a
                                className="btn-primary btn-grid"
                                onClick={() => {
                                  setCurrentView(3);
                                  setPaymentCriteriaData(item);
                                }}
                                title={"Edit"}
                              >
                                <img
                                  src="images/edit.svg"
                                  width={15}
                                  height={15}
                                />
                              </a>}
                              {getAccessSettings(2, 14) > 1 && <a
                                className="btn-primary btn-grid"
                                // onClick={() => {
                                //   IBBPaymentCriteriaDeleteRecordCustom(
                                //     item.IBBPaymentCriteriaID
                                //   );
                                // }}
                                onClick={() => {
                                  globalState.setConfirmationObject({
                                    ShowPopup: true,
                                    Heading: "Confirmation ",
                                    Message: "Are you sure you want to delete this record?",
                                    ID: 1,
                                    SelectedID:item.IBBPaymentCriteriaID
                                  });
                                }}
                                title="Delete"
                              >
                                <img
                                  src="images/delete.svg"
                                  width={15}
                                  height={15}
                                />
                              </a>}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {(currentView == 2 || currentView == 3 || currentView == 4) && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            {currentView == 2 && canEdit && <a>Add Payment Criteria</a>}
            {currentView == 3 && canEdit && <a>Edit Payment Criteria</a>}
            {!canEdit && <a>Payment Criteria Details</a>}
          </div>
          <div className="page--data">
            <div className="program-form">
              <div className="form-item">
                <span>Name:</span>
                <input
                  type="text"
                  value={PaymentCriteriaData.Name}
                  onChange={(e) =>
                    setPaymentCriteriaData((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="form-btns">
                <>
                  <a
                    className="btn-primary btn-grid btn-secs"
                    onClick={() => IBBPaymentCriteriaSaveCustom()}
                  >
                    Save
                  </a>
                </>

                <a
                  className="btn-primary btn-grid btn-secs"
                  onClick={() => {
                    setCurrentView(1);
                    IBBPaymentCriteriaGetCompleteGridDataCustom();
                  }}
                >
                  Back to List View
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
